import React from "react";

type HamburgerSVGProps = {
  color?: string;
  size?: number;
  className?: string;
};

/** Standard three-line menu icon for sidebar open/collapse toggles. */
function HamburgerSVG({
  color = "#232323",
  size = 20,
  className,
}: HamburgerSVGProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M4 7H20"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M4 12H20"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M4 17H20"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default HamburgerSVG;
